module.exports = __webpack_public_path__ + "../resources/images/illustration_access_error-c07ca63f653df39bb0ae5089e9ed0252.svg";